import { render } from "./star-rating.vue?vue&type=template&id=8c847830&scoped=true"
import script from "./star-rating.vue?vue&type=script&lang=js"
export * from "./star-rating.vue?vue&type=script&lang=js"

import "./star-rating.vue?vue&type=style&index=0&id=8c847830&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c847830"]])

export default __exports__